import React from 'react';
// import PropTypes from "prop-types";
import "./Footer.css";

function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-4">
      <div className="container mx-auto flex justify-between items-center">
        <div>
          <p>&copy; 2024 BuzzerDraw. All rights reserved.</p>
        </div>
        <div>
          <a href="https://facebook.com" className="text-white mr-4">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://twitter.com" className="text-white mr-4">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://instagram.com" className="text-white mr-4">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
